<template>
<div class="publications">
  <div class="section is-medium">
    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-one-quarter">
          <h1 class="deneme">PUBLICATIONS</h1>
        </div>
        <div class="column tile is-parent is-vertical is-6">
            <span class="">
              <ul>
                <H3>ARTICLES</H3><br>
                
                <small>Duty of Buyer to Mitigate Damages under the CISG</small><br>
                <li><strong>Publication Date</strong> : Dec 16, 2016</li><br>
                <li><strong>Publisher</strong> : Galatasaray University Law Review 2016 - 2</li><br>
                <li><strong>Abstract</strong> Under the United Nation Convention on the International Sale of Goods (CISG), both parties have the duty to mitigate losses. In practise, it is observed that the buyer usually relies on a breach of contract and consequently, most of the time, it is the buyer who has the duty to mitigate damages. Under the duty of mitigation of damages, the buyer must take reasonable measures to mitigate his losses. If he fails to take reasonable measures, he must bear the amount of damages which should have been mitigated. Theoretically, the concept of the duty to mitigate damages is clear, though it might cause uncertainties in practice. It is not always so easy for parties, courts and arbitral tribunals to determine which measures are reasonable under which conditions.</li><br>
                <br>
                <br>
                <small>Termination of Surety and Guarantee Contracts</small><br>
                <li><strong>Publication Date</strong> : Sep 1, 2016</li><br>
                <li><strong>Publisher</strong> : Union of Turkish Bar Association Review 126, 311-338.</li><br>
                <li><strong>Abstract</strong> Surety and guarantee contracts are the most common types of personal guarantee contracts. Although they have some resembling aspects, there are significant differences when it comes to termination. The foremost reason is that a guarantee contract is independent from the underlying contract, on the other hand, a surety contract has ancillary character. In addition, the termination of surety contract is enacted in the Turkish Code of Obligations but there is no regulation on termination of guarantee contract.</li><br>
                <br>
                <br>
                <small>The Past, the Present and the Future of Colour and Smell Marks</small><br>
                <li><strong>Publication Date</strong> : Aug 1, 2016</li><br>
                <li><strong>Publisher</strong> : European Intellectual Property Review 38(8), 504-516</li><br>
                <li><strong>Abstract</strong> Non-traditional trade marks have become part of commerce and advertising but they continue to struggle in finding a place in the current EU trade mark system. The reason for this, simply, is that the current EU trade mark system is based on traditional trade marks, such as words, names, letters and logos. However, the system has been pushed increasingly by traders wanting to register non-traditional trade marks. This paper specifically focuses on colour and smell trade marks and tries to set out how these kinds of non-traditional trade marks can be registrable under the EU law. In this context, there are two main obstacles; the graphical representation requirement and the distinctiveness requirement. Registration problems of non-traditional trade marks impelled the European Commission to revise the current situation of the functioning of the EU trade mark system and this has resulted in proposals for, both, a new trade mark Directive and Regulation. These proposals suggested to abolish the graphical representation requirement and to include colours and sounds as examples for signs that may constitute a trade mark.</li><br>
                <br>
                <br>
                <small>Should Copyright Law Protect Advertising Slogans</small><br>
                <li><strong>Publication Date</strong> : Mar 1, 2016</li><br>
                <li><strong>Publisher</strong> : European Intellectual Property Review 38, Issue 3, 172-177</li><br>
                <li><strong>Abstract</strong> Advertisements might have different motives in their creation process but it is not possible to deny that they are important outcomes of intellectual creations. An important part of advertising activities is advertising slogans. Some of them can be protected by trademark law but this paper focuses on the potential copyright aspect of advertising slogans. On the one hand, they are different than other types of copyright works because they are too short but on the other hand, some of them are capable of conveying ideas and emotions. In this paper, different arguments against and for providing copyright protection to advertising slogans are going to be discussed.</li><br>
                <br>
                <br>
                <small>TV Copycatting: Determining the Threshold Between Legal Copying and Copyright Infringement</small><br>
                <li><strong>Publication Date</strong> : Apr 30, 2015</li><br>
                <li><strong>Publisher</strong> : Gazi University Law Review 19, Issue 2, 137-148</li><br>
                <li><strong>Abstract</strong> TV formats are so popular and widely traded all around the world. Therefore, they lead highly-profitable business and this turns TV formats into precious assets. Hence, it is essential to protect these assets in legal context. The problem is that TV formats are composed of ideas and concepts and these are not under protectionof copyright law. So, is it free to copy a whole format? Of course not, but there is a thin and blurry line between legal copying and copyright infringement. This paper aims to provide help on the determination of the threshold between legal copying and copyright infringement.</li><br>
              </ul>
                <br>
                <br>
                <small>Jurisdiction Agreements under Administrative Law</small><br>
                <ul>
                <li><strong>Publication Date</strong> : November, 2009</li><br>
                <li><strong>Publisher</strong> : Mahalli İdareler Aylık Mesleki ve Mevzuat Dergisi, Issue 183, 35-38.</li><br>
                <li><strong>Abstract</strong> Although it is clear that jurisdiction agreements are possible under private law, it is a debate whether it is possible to enter into jurisdiction agreement under administrative law. Auction process no doubt falls within the administrative law. Within this process, administrative specifications and agreements may contain articles regarding competent courts. Local courts might dismiss the case by relying on these articles. However, since there is no specific rule, there exists legal gap and this Article concentrates on the question of whether jurisdiction agreements are possible under administrative law.</li><br>
              </ul>
              <ul>
                <H3>BOOKS</H3><br>
                
                <small>Termination of Professional Football Player’s Contract and the Resolution Process of The Disputes Arising from Termination</small><br>
                <li><strong>Publication Date</strong> : Dec 29, 2016</li><br>
                <li><strong>Publisher</strong> : On İki Levha Yayıncılık A. Ş.</li><br>
                <li><strong>Abstract</strong> Professional football players’ contracts have a substantial role in professional football, as they regulate the legal relationship between players and clubs. Because of the self-enclosed characteristic of professional football, it is usually not possible to come across with disputes which are made a matter of law between players and clubs..</li><br>
              </ul>
              <ul>
                <H3>SEMINARS</H3><br>
                
                <small>Seminar organized by the Istanbul Bar Association and Istanbul Bilgi University on the Recent Problems of Maritime Enforcement Law</small><br>
                <li><strong>Date</strong> : 13 May, 2017</li><br>
              </ul>
              <ul>
                <H3>NEWS</H3><br>
                
                <small>Pros and Cons of the New Regulation Regarding Yachts Flying With Foreign Flag</small><br>
                <li><strong>Date</strong> : April, 2017</li><br>
                
                <li><strong>Description</strong> PARA – Weekly Financial Magazine</li><br>
              </ul>
            </span>
         
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'publications',
  data () {
    return {
        
        }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .publications p {
    font-size: 1.5rem;
    }

    #app {
        background: #606c96;
    }
    .publications h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
    }
    .publications h1 {
      position: relative;
      color: #504f50;
    }
    .publications h3 {
    position: relative;
    color: #504f50;
    font-size: 30px;
    } 
    small {
      font-size: 1.2rem;
      font-weight: 900;
      text-transform: uppercase;
      display: inline-block;
      padding-bottom: 20px;
      }
      .publications ul li {
        text-align: justify;
        list-style: none;
      }
      @media only screen and (max-width: 768px) {
      .publications {
        margin-bottom: 100px;
      }
      .publications h1 {
        font-size: 25px;
      }
        div.column.is-one-quarter::after {
        content: "";
        position: absolute;
        right: 12%;
        top: 0;
        height: 100%;
        background:unset;
        width: 1px;
      }
      }
    
</style>



// WEBPACK FOOTER //
// publications.vue?17e49476